import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "three-dots--sprite",
  "use": "three-dots--sprite-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"three-dots--sprite\">\n<circle cx=\"12.5\" cy=\"6.5\" r=\"1.5\" fill=\"currentColor\" />\n<circle cx=\"12.5\" cy=\"12.5\" r=\"1.5\" fill=\"currentColor\" />\n<circle cx=\"12.5\" cy=\"18.5\" r=\"1.5\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol